import Vue from 'vue'
import Router from 'vue-router'
//  import Hello from '@/components/Hello'
//  import Par from '@/components/Par'
//  import MapView from '@/components/MapView'
import Start from '@/components/Start'
/* import Ar from '@/components/Ar' */
//  import Profile from '@/components/Profile'
/* import Battle from '@/components/Battle'
import MapViewMapBox from '@/components/MapViewMapBox'
import Tutorial from '@/components/Tutorial'
import Vote from '@/components/Vote'
import Testing from '@/components/Testing'
import Arworld from '@/components/Arworld'
import Votev from '@/components/Votev' */
import Arex from '@/components/Arex'
import WinnerFeed from '@/components/WinnerFeed'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start
    },
    {
      path: '/arex',
      name: 'arex',
      component: Arex
    }, /*
    {
      path: '/par',
      name: 'par',
      component: Par
    }, */
    {
      path: '/winners',
      name: 'winners',
      component: WinnerFeed
    }/*
    {
      path: '/map',
      name: 'map',
      component: MapViewMapBox
    },
    {
      path: '/world',
      name: 'world',
      component: Arworld
    },
    {
      path: '/test',
      name: 'test',
      component: Testing
    },
    {
      path: '/ar',
      name: 'ar',
      component: Ar
    },
    {
      path: '/battle',
      name: 'battle',
      component: Battle
    },
    {
      path: '/vote',
      name: 'vote',
      component: Vote
    },
    {
      path: '/votev',
      name: 'votev',
      component: Votev
    },
    {
      path: '/map_old',
      name: 'map_old',
      component: MapView
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: Tutorial
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/hello',
      name: 'hello',
      component: Hello
    } */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js